(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
if (!customElements.get("s-footer")) {
  customElements.define(
    "s-footer",
    class SectioFooter extends HTMLElement {
      constructor() {
        super();

      }

      connectedCallback() {
        this.details = Array.from(this.querySelectorAll(".js-footer__details"));

        this.resizeHandler();
        window.addEventListener("resize", this.resizeHandler);
      }

      disconnectedCallback() {
        window.removeEventListener("resize", this.resizeHandler)
      }

      resizeHandler = () => {
        if(window.innerWidth >= 992) {
          this.details.forEach(el => el.setAttribute("open", ""))
        } else {
          this.details.forEach(el => el.removeAttribute("open"))
          this.details[0]?.setAttribute("open", "");
        }
      }
     }
  );
}

},{}]},{},[1])

